import { translateWithFallback } from '@/i18n/translationUtils';
import { localizeInfectionPreventionTerminology } from '@/utils/sector';

export function getGuardianField(
    guardian,
    field,
    translateFn,
    countryCode,
    locale
) {
    const value = translateWithFallback(
        translateFn,
        `guardians.cards.items.${guardian?.id}.${field}`,
        ''
    );

    return localizeInfectionPreventionTerminology(value, countryCode, locale);
}

export function getGuardianLabel(guardian, translateFn, countryCode, locale) {
    return getGuardianField(guardian, 'label', translateFn, countryCode, locale);
}
